import {z} from 'zod';
import {mapNullToUndefined} from '../utils/zod.ts';

export const fieldSchema = z.object({
  name: z.string(),
  type: z.string(),
  sortOrder: z.number(),
  inactive: z.boolean(),
  partnerSiteIds: mapNullToUndefined(z.array(z.number()).optional()),
});

export type FieldSchema = z.TypeOf<typeof fieldSchema>;
